import SocialMediaInfoContent from './SocialMediaInfoContent';

export default SocialMediaInfoContent;
